export const customerPublic= {
  data(){
    return {
      customerServiceId:'',
      showServiceDetail: false,
      customerInfo:{}
    }
  },
  methods: {
    closeTitlePop:function(flag,deleteStyle){
      this.showTitlePop=false;
      if (flag) {
        if (deleteStyle=='0'){//选中结果删除
          if (this.checkIds.length==0){
            this.$Modal.info({
              title:'提示',
              content:"当前无可删除的客户"
            });
            return false;
          }
          let param={
            id:this.checkIds.toString(),
            journalType:this.journalType+"按选中结果删除",
            menuId:this.menuId
          };
          if (!this.deleteUrl) {
            param.operateType="delete";
          }
          this.operateCustomer(param)
        }
        if (deleteStyle=='1'){//搜索结果删除
          if(this.contentList.length==0){
            this.$Modal.info({
              title:'提示',
              content:"当前无可删除的客户"
            });
            return false;
          }
          if(!this.queryParam){
            this.$Modal.info({
              title:'提示',
              content:"请点击查询后再删除"
            });
            return false;
          }
          delete this.queryParam["pageNum"];
          delete this.queryParam["pageSize"];

          this.$set(this.queryParam, 'type', deleteStyle);
          this.$set(this.queryParam, 'journalType', this.journalType+"按搜索结果删除");
          this.$set(this.queryParam, 'menuId', this.menuId);
          
          if (!this.deleteUrl) {
            this.$set(this.queryParam, 'operateType', "delete");
          }
          // this.getParam(this.formValidate,param);
          this.operateCustomer(this.queryParam)
        }
      }
    },
    batchDeleteOperate:function(journalType,menuId){
      this.journalType=journalType;
      this.menuId=menuId;
      this.showTitlePop=true;
    },
   applyCustomer:function(journalType,menuId){
      this.journalType=journalType;
      this.menuId=menuId;
     this.showPublicPop=true;
     this.popSign="申请客户";
    },
    deleteOperate:function(journalType,menuId,id){
      let param={
        operateType:'delete',
        id:id,
        journalType:journalType,
        menuId:menuId
      };
      if (this.deleteUrl) {
        param={
          id:id,
          journalType:journalType,
          menuId:menuId
        };
      }
      this.operateCustomer(param)
    },
    operateCustomer:function (param) {
      let that=this;
      let url="customer/operateCustomer.json";
      if (this.deleteUrl) {
        url=this.deleteUrl;
      }
      this.$Modal.confirm({
        title: '提示',
        content: "是否确定删除",
        onOk: () => {
          that.$http.post(url,param) .then(function (res) {
            let result = res.data.flag;
            if(result!="666"){
              that.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
              });
              return false;
            }
            that.$Message.info("删除成功");
            that.initSearch();
          });
        }
      });
    },
    editInsertCustomer:function (journalType,menuId,id) {
      this.journalType=journalType;
      this.menuId=menuId;
      this.searchId=id+"";
      this.showInsertPop=true;
      this.showCustomerTitle="编辑客户";
    },
    addInsertCustomer:function (journalType,menuId) {
      if(this.formValidate.allColumnInfo.length==0){
          return false;
      }
      this.journalType=journalType;
      this.menuId=menuId;
      this.searchId="";
      this.showInsertPop=true;
      this.showCustomerTitle="添加客户";
    },
    closeInsertCustomer:function (flag) {
      this.showInsertPop=false;
      if(flag){
        this.initSearch();
      }
    },
    closefile: function () {
      this.showfile = false;
    },
    initSearch:function (index) {
      this.spinShow=true;
      let selectCount=false;
      let list=this.formValidate.searchList;
      for (let i=0;i<list.length;i++){
        let customValue=list[i].customValue;
        if(customValue){
          selectCount=true;
        }
      }
      let param={
        pageNum:this.currentPage,
        pageSize:this.pageSize,
        journalType:"null",
        menuId:"null",
        selectCount:selectCount,
        customerType: this.customerType,
        customerScope:this.formValidate.customerScope,
        customerState:this.formValidate.customerState
      };
      this.speedChangePage=this.currentPage;
      this.getParam(this.formValidate,param);
      let url="customer/selectAllCustomer.json";
      if(!index){
        index=2
      }
      this.publicSearch(url,param,index);
    },
    closeServiceDetail:function () {
      this.showServiceDetail=false;
    },
    openServiceDetail:function (id,customerInfo) {
      this.showServiceDetail=true;
      this.customerServiceId=id;
      this.customerInfo=customerInfo;
    },
    //打开客户轨迹
    openCustomerTrajectory:function (obj) {
      this.showCustomerTrajectory=true;
      this.trajectoryId=obj.id+'';
      this.customerName=obj.customerName;
    },
    //关闭客户轨迹
    closeCustomerTrajectory:function () {
      this.showCustomerTrajectory=false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/js/CustomerPublic.js